import { PageContainer, ProDescriptions } from "@ant-design/pro-components";
import { Button, Card, notification } from "antd";
import { useCallback, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { LeagueGamesAPI } from "../../../api/leagueGames";
import dayjs from "dayjs";
import { CopyOutlined } from "@ant-design/icons";

const BASE_URL = process.env.REACT_APP_BASE_BASE_URL_CLIENT;

const DetailLeagueGames = () => {
  const navigate = useNavigate();

  const { id } = useParams();
  const { getDetailLeagueGames } = LeagueGamesAPI;

  const [detailLeagueGame, setDetailLeagueGame] = useState(null);

  const handleFetchDetail = useCallback(async () => {
    try {
      const { data } = await getDetailLeagueGames(id);

      setDetailLeagueGame(data);
    } catch (error) {
      console.log("🚀 ===== error:", error);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const handleCopyLink = (link) => {
    navigator.clipboard
      .writeText(link)
      .then(() => {
        notification.success({ message: "Link copied to clipboard!" });
      })
      .catch(() => {
        notification.error({ message: "Failed to copy the link." });
      });
  };

  useEffect(() => {
    handleFetchDetail();
  }, [handleFetchDetail]);

  return (
    <PageContainer
      title="League Game detail"
      extra={[
        <Button
          key="edit-waiting-room"
          type="primary"
          onClick={() => navigate(`/league-game/edit/${detailLeagueGame.id}`)}
        >
          Edit League Game
        </Button>,
      ]}
    >
      <Card title="League Game Information">
        <ProDescriptions column={1}>
          <ProDescriptions.Item label="League Game ID" valueType="text">
            {detailLeagueGame?.id}
          </ProDescriptions.Item>
          <ProDescriptions.Item label="League Game Name Ar" valueType="text">
            {detailLeagueGame?.nameAr}
          </ProDescriptions.Item>
          <ProDescriptions.Item label="League Game Name En" valueType="text">
            {detailLeagueGame?.nameEn}
          </ProDescriptions.Item>
          <ProDescriptions.Item label="Is Active" valueType="text">
            {detailLeagueGame?.isEnable ? "True" : "False"}
          </ProDescriptions.Item>
          <ProDescriptions.Item label="Link" valueType="text">
            <p className="link">
              {`${BASE_URL}league-games/${detailLeagueGame?.id}?TAG=FOOTBALL_EVENT_GAME_BY_LOCATE`}
            </p>
            <button
              type="button"
              className="copy"
              onClick={() =>
                handleCopyLink(
                  `${BASE_URL}league-games/${detailLeagueGame?.id}?TAG=FOOTBALL_EVENT_GAME_BY_LOCATE`
                )
              }
            >
              <CopyOutlined />
            </button>
          </ProDescriptions.Item>
          <ProDescriptions.Item label="Started at">
            {dayjs(detailLeagueGame?.startTime).format("YYYY-MM-DD HH:mm")}
          </ProDescriptions.Item>
          <ProDescriptions.Item label="Ended at">
            {detailLeagueGame?.endTime
              ? dayjs(detailLeagueGame?.endTime).format("YYYY-MM-DD HH:mm")
              : "--"}
          </ProDescriptions.Item>
          <ProDescriptions.Item label="Created at">
            {dayjs(detailLeagueGame?.createdAt).format("YYYY-MM-DD HH:mm")}
          </ProDescriptions.Item>

          {detailLeagueGame?.LeagueClub.map((club, index) => (
            <ProDescriptions.Item key={club.id} label={`Club ${index + 1}`}>
              {club.club.nameEn}
            </ProDescriptions.Item>
          ))}

          {detailLeagueGame?.LeagueClub.map((club, index) => (
            <ProDescriptions.Item
              key={club.id}
              label={`Link Club ${index + 1}`}
            >
              <p className="link">{club.url}</p>
              <button
                type="button"
                className="copy"
                onClick={() => handleCopyLink(club.url)}
              >
                <CopyOutlined />
              </button>
            </ProDescriptions.Item>
          ))}
        </ProDescriptions>
      </Card>
    </PageContainer>
  );
};

export default DetailLeagueGames;
